<template>
  <div class="difference">
    <split-container direction="up" top-brand-color="white" bottom-brand-color="yellow">
      <template v-slot:top>
        <div class="top-container">
          <div class="difference-text">
            <div class="breadcrumb">03&nbsp;&mdash;&nbsp;The Zespri Difference</div>
            <div class="difference-intro">
              <h2>The Zespri Difference</h2>
              <p>What makes Zespri SunGold Kiwifruit so sweet? A whole lot of care and attention.</p>
              <a href="/en-US/blogdetail/where-are-kiwifruit-grown" target="_blank" class="learn-btn">Learn about our process</a>
            </div>
          </div>
          <div class="difference-image">
            <div class="breadcrumb">03&nbsp;&mdash;&nbsp;The Zespri Difference</div>
            <div class="difference-carousel">
              <slick
                ref="slick"
                :options="slickOptions">
                <img src="../../src/assets/difference/location-carousel-slide.png">
                <img data-src="./assets/difference/care-carousel-slide.png">
                <img data-src="./assets/difference/maturity-carousel-slide.png">
              </slick>
              <button id="carouselPrev" ref="carouselPrev" class="fern-carousel-arrow fern-carousel-prev">
                <carousel-prev-arrow></carousel-prev-arrow>
              </button>
              <button id="carouselNext" ref="carouselNext" class="fern-carousel-arrow fern-carousel-next">
                <carousel-next-arrow></carousel-next-arrow>
              </button>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:bottom>
        <div class="bottom-container">
          <div class="growers-image">
            
            <!-- <svg version="1.1" class="growers-image-curve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 134.3 741.2" style="enable-background:new 0 0 134.3 741.2;" xml:space="preserve">
              <path d="M0,0.1c67.6,122.4,102.6,260.6,101,400.1c-1.3,117.7-28.7,234.5-80,340.9c37.7,0.3,75.3-0.3,113,0
            c-1-247,1-494,0-741C90.3,0.4,43.7-0.2,0,0.1z"/>
            </svg> -->
            
            <growers-image-curve></growers-image-curve>
            
            <button class="growers-btn hide-for-launch">Meet the growers</button>
          </div>
          <div class="growers-text">
            <stacked-headline class="growers-text-headline"
              top-text="The Golden"
              top-color="dark-green"
              bottom-text="Growers"
              bottom-color="white">
            </stacked-headline>
            <p>Zespri is owned by experienced growers who share a passion for kiwifruit and a commitment to high taste and quality standards. They ensure that each and every piece of fruit grows to have that delicious taste and sweetness Zespri SunGold is loved for.</p>
          </div>
        </div>
      </template>
    </split-container>
  </div>
</template>

<script>
import SplitContainer from '../components/SplitContainer.vue'
import StackedHeadline from '../components/StackedHeadline.vue'
import previousArrow from '../assets/icons/carousel-prev-arrow.svg?inline'
import nextArrow from '../assets/icons/carousel-next-arrow.svg?inline'
import ImageCurve from '../assets/difference/growers-image-curve.svg?inline'
import Slick from 'vue-slick'

export default{
  name: 'difference',
  components: {
    'split-container': SplitContainer,
    'stacked-headline': StackedHeadline,
    'carousel-prev-arrow': previousArrow,
    'carousel-next-arrow': nextArrow,
    'growers-image-curve': ImageCurve,
    'slick': Slick
  },
  props: {
    active: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      slickOptions: {
        prevArrow: '#carouselPrev',
        nextArrow: '#carouselNext',
        fade: true
      }
    }
  }
}
</script>

<style unscoped lang="scss">
  .difference {
    .top,
    .bottom {
      overflow: hidden;
    }

    .top {
      z-index: 0 !important;
      flex: 1.1;
      transform: scaleY(1.1);
      .content {
        transform: scaleY(.9);
      }
    }

    .bottom{
      flex: 0.9;
    }
  }
</style>

<style scoped lang="scss">
/** difference **/
@import '../theme';
@import '../../node_modules/slick-carousel/slick/slick.css';

.difference {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;

  @include media-breakpoint-up(lg) {
    height: 100vh;
    min-height: 850px;
  }
}

.container{
  @include media-breakpoint-up(lg) {
    height: 100vh;
    min-height: 850px;
  }
}



.top-container {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-self: flex-start;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    align-items: stretch;
  }

  .difference-text {
    display: flex;
    flex-direction: column;
    padding: 20vw 32px 64px 32px;
    order: 2;

    @include media-breakpoint-up(md) {
      width: 50%;
      padding: 2% 0 2% 7vw;
      justify-content: space-between;
      order: 1;
    }

    @include media-breakpoint-up(lg) {
      width: 40%;
    }

    .breadcrumb {
      display: none;

      @include media-breakpoint-up(md) {
        display: block;
      }
    }

    .difference-intro {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      height: 100%;
      justify-content: center;

      @include media-breakpoint-up(md) {
        padding: 32px;
      }
    }
  }

  .difference-image {
    position: relative;
    order: 1;

    @include media-breakpoint-up(md) {
      width: 50%;
      order: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .breadcrumb {
        display: none;
      }
    }

    @include media-breakpoint-up(lg) {
      width: 60%;
    }

    .breadcrumb {
      display: block;
      padding: 7vw;

      @include media-breakpoint-up(md) {
        display: none;
      }
    }

    .difference-carousel {
      position: relative;
      overflow: visible;
      width: 80%;
      margin: 0 auto 15px auto;

      @include media-breakpoint-up(md) {
        width: 60%;
        margin: 0 auto;
        transform: translateY(60px);
      }

      &:after {
        content: '';
        position: absolute;
        top: 46.5%;
        left: 49.5%;
        transform: translateX(-50%) translateY(-50%);
        width: 120.5%;
        height: 119%;
        background-image: url('../assets/difference/fern-carousel-surround.png');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 90%;
        z-index: zespro-layer(slideshow);
        overflow: visible;

        @include media-breakpoint-up(md) {
          background-size: 100% 92%;
        }
      }

      .fern-carousel-arrow {
        position: absolute;
        z-index: zespri-layer(slideshow);
        display: block;
        background: transparent;
        border: 0;
        width: 42px;
        height: 55px;
        top: 102%;
        cursor: pointer;
        fill: zespri-brand-color(green);
        transition: fill .2s;

        @include media-breakpoint-up(md) {
          width: 30px;
          height: 60px;
          top: 50%;
          transform: translateY(-50%);
        }

        img {
          width: 100%;
        }

        &:focus {
          outline: 0;
        }
        
        &:hover {
          fill: zespri-brand-color(dark-green);
        }
      }

      .fern-carousel-prev {
        left: 25%;

        @include media-breakpoint-up(md) {
          left: -25%;
        }

        @include media-breakpoint-up(lg) {
          left: -20%;
        }
      }

      .fern-carousel-next {
        right: 25%;

        @include media-breakpoint-up(md) {
          right: -25%;
        }

        @include media-breakpoint-up(lg) {
          right: -20%;
        }
      }
    }
  }
}

.breadcrumb {
  @include zespri-tiny-title;
  color: zespri-brand-color(dark-green);
}

.learn-btn {
  @include cta-button(zespri-brand-color(dark-green), zespri-brand-color(green));
}

.growers-btn {
  @include cta-button(zespri-brand-color(dark-green), $white);
}

.bottom-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 -2.5%;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
  }

  .growers-image {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-image: url('../assets/difference/grower-trees.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 100vw;

    @include media-breakpoint-up(md) {
      width: 50%;
      height: auto;
    }

    @include media-breakpoint-up(lg) {
      width: 40%;
    }

    .growers-image-curve {
      position: absolute;
      top: auto;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 100%;
      transform: rotate(90deg) translateX(40%) scale(1.05);
      fill: zespri-brand-color(yellow);

      @include media-breakpoint-up(md) {
        top: 0;
        bottom: 0;
        left: auto;
        right: -15px;
        width: auto;
        max-width: 120px;
        transform: rotate(0) scale(1.05);
      }
    }
  }

  .growers-text {
    position: relative;
    box-sizing: border-box;
    padding: 32px;

    @include media-breakpoint-up(md) {
      width: 50%;
      padding: 5%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    @include media-breakpoint-up(lg) {
      width: 60%;
    }

    .growers-text-headline {
      position: relative;
      margin-left: 12%;

      @include media-breakpoint-up(md) {
        margin-left: 0;
      }

      &:after {
        content: '';
        width: 25%;
        height: 110%;
        position: absolute;
        right: 5%;
        bottom: 10%;
        background-image: url('../assets/difference/kiwi-bird.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }

    p {
      @include media-breakpoint-up(md) {
        width: 80%;
      }
    }
  }
}
</style>
